module.exports = __webpack_public_path__ + "img/background_principal_mov-300.83e0698e.webp";